import React, { createContext, useState, useCallback } from 'react';

export const ReportContext = createContext();

export const ReportProvider = ({ children }) => {
  const [currentReport, setCurrentReport] = useState(null);

  const viewReport = useCallback((report) => {
    setCurrentReport(report);
  }, []);

  const clearReport = useCallback(() => {
    setCurrentReport(null);
  }, []);

  const value = {
    currentReport,
    viewReport,
    clearReport
  };

  return (
    <ReportContext.Provider value={value}>
      {children}
    </ReportContext.Provider>
  );
};

export const useReportContext = () => {
  const context = React.useContext(ReportContext);
  if (!context) {
    throw new Error('useReportContext must be used within ReportProvider');
  }
  return context;
};
